import React from "react";
import Modal from "react-bootstrap/Modal";

const DeleteAddressModal = ({ show, onHide, deleteAddress }) => {
  return (
    <Modal
      show={show}
      onHide={onHide}
      size="md"
      backdrop={true}
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="kitchen-modal"
    >
      <Modal.Header closeButton>
        <span className="fw-bold">حذف آدرس </span>
      </Modal.Header>
      <Modal.Body>
        <div>
          <div>
            <div className="modal-body p-3">
              <p className="fs-5 py-3 mx-1">
                آیا از حذف این آدرس اطمینان دارید؟
              </p>
              <div className="d-flex justify-content-around align-content-center">
                <button
                  type="button"
                  className="btn custome-btn btn-outline-purple w-50 ms-2"
                  onClick={onHide}
                >
                  خیر
                </button>
                <button
                  type="button"
                  className="btn custome-btn btn-danger w-50 me-2"
                  onClick={deleteAddress}
                >
                  بله
                </button>
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default DeleteAddressModal;
